var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 3V9H19V19H1V5H7V3L10 0L13 3ZM2.99951 17.0007H4.99951V15.0007H2.99951V17.0007ZM4.99951 12.9995H2.99951V10.9995H4.99951V12.9995ZM2.99951 9.00049H4.99951V7.00049H2.99951V9.00049ZM11.0002 17.0007H9.00024V15.0007H11.0002V17.0007ZM9.00024 12.9995H11.0002V10.9995H9.00024V12.9995ZM11.0002 9.00049H9.00024V7.00049H11.0002V9.00049ZM9.00024 4.99927H11.0002V2.99927H9.00024V4.99927ZM17.001 17.0007H15.001V15.0007H17.001V17.0007ZM15.001 12.9995H17.001V10.9995H15.001V12.9995Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/city.e6eb7b5df137918b3df87898264917e5.svg";
export { ForwardRef as ReactComponent };